import Vue from 'vue'
import Axios from 'axios'
import Cons from '@/constants.json'
import * as API from '@/endpoints'

export default {
    namespaced: true,
    state: {
        skin: {}
    },
    getters: {
        mySkin(state) {
            return state.skin;
        }
    },
    mutations: {
        setSkin(state, v){
            state.skin = v
        }
    },
    actions: {
        fetchAppTheme({commit, rooState}, payload){
            console.log( payload )
            new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(
                        commit('setSkin', 
                           {
                                toolbar: {
                                    title_color: 'white',
                                    back_button: 'white',
                                    menu_button: 'white',
                                    background_color: 'black'
                                },
                                bottom_navigation: {
                                    background_color: 'black',
                                    icon_color: 'grey',
                                    icon_highlight_color: 'white'
                                },
                                theme: {
                                    primary_color: 'black',
                                    link_color: 'black',
                                    info_color: 'blue',
                                    success_color: 'green',
                                    warning_color: 'orange',
                                    error_color: 'red',
                                }
                           }
                        )
                    )
                }, 2000);
            })
        }
    }
}